import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { UploadKaroakeRequest } from '../api/karoake/uploadkaroake/uploadkaroakerequest';
import { UploadKaroakeResponse, UploadKaroakeResponseDtoImpl } from '../api/karoake/uploadkaroake/uploadkaroakeresponse';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { APIProcessor } from './apiProcessor';
import { Strings } from '../../utils/resources/strings';

export class UploadKaroakeAPIProcessorImpl extends SixdeeCRBTAPIProcessor<UploadKaroakeRequest, UploadKaroakeResponse>
{
    private uploadPregress: (percentage: number) => void;

    execute(request: UploadKaroakeRequest): void 
    {
        super.execute(request);
    }

    
    uploadProgress(uploadProgress: (percentage: number) => void): APIProcessor<UploadKaroakeRequest, UploadKaroakeResponse> {
       this.uploadPregress = uploadProgress;

       return this;
    }

    onUploadProgress(percentage: number): void 
    {
       this.uploadPregress(percentage);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new UploadKaroakeResponseDtoImpl(APIFeatures.UPLOAD_KAROAKE, "Upload Karoake Success");

                this.getAPISuccess(response);
            }
        }
        catch (e) {
            this.getAPIFailure(new UploadKaroakeResponseDtoImpl(APIFeatures.UPLOAD_KAROAKE, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);

            this.getAPIFailure(new UploadKaroakeResponseDtoImpl(APIFeatures.UPLOAD_KAROAKE, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/uploadkaroakeapiprocessor.tsx